import React, { useEffect } from "react";
import HeaderRouting from "./services/header-routing";
import { BrowserRouter, Route } from "react-router-dom";
import { StateProvider } from "./services/StateProvider";
import { AccountInfoUpdate, initialAccountState } from "./services/StateMap";
import "./App.css";
import FooterNavigation from "./common-components/footer/footer";
import HeaderApi from "./common-components/header/services/header-apis";
import LoginApis from "../src/scenes/login/services/LoginService";
import LogIn from "./scenes/login/components/LogIn";
const mainReducer = (state, action) => {
  return {
    accountInfo: AccountInfoUpdate(state.accountInfo, action),
  };
};

function App() {
  const headerApi = new HeaderApi();
  const LoginApi = new LoginApis();

  useEffect(() => {

    sessionStorage.setItem("isAuthenticated", false);
    sessionStorage.setItem("isOnlyUser", false);

    LoginApi.checkLoginStatus().then((response) => {
      let identifier = "is authenticated";

      if ((response?.status !== 401) && response.includes(identifier)) {

        sessionStorage.setItem("isAuthenticated", true);
        sessionStorage.setItem("hasLoggedIn", true);

        if (sessionStorage.getItem("isAuthenticated")==="true") {
          headerApi.getUserPreference().then((response) => {
            const model = response.model;
            headerApi.getUserProfile().then((data) => {
  
              if (data.status === 204) {
                let date = new Date();
                date = date.toISOString();
                const userDetailsCurrent = {
                  userId: "",
                  firstName: "",
                  middleName: "",
                  lastName: "",
                  userRole: "",
                  updatedDate: date,
                  phoneNumber: ""
                };
                globalAccountStateUpdate(model, userDetailsCurrent);
                //temporary commented
                // headerApi.createUser(userDetailsCurrent).then((_data) => {
                // });
              }
               else {
                  globalAccountStateUpdate(model, data.model);
              }
            });
          });
          

        }

        const globalAccountStateUpdate = (model, userProfile) => {
          const initialAccountState = {
            account: {
              accountName: model.lastAccessedAccountName,
              accountId: model.lastAccessedAccountId
            },
            location: [
              {
                value: model.lastAccessedLocationId,
                label: model.lastAccessedLocationName
              }
            ],
            userSetting: model,
            userProfile
          };
          localStorage.setItem("accountInfo", JSON.stringify(initialAccountState));
          localStorage.setItem("accountInfoUserMeasurementSystemValue", JSON.stringify(initialAccountState.userSetting.userMeasurementSystemValue));

          if (window.location.pathname !== "/authentication/callback") {
            localStorage.setItem("loadedURL", window.location.pathname);
          } else {
            return;
          }
        };
          
      } else {
        let accountData = {
          account: { accountName: "app", accountId: "0000" },
          location: [{ value: 0, label: "" }],
          userSetting: {
            userId: "",
            userLanguage: "en-us",
            userMeasurementSystemValue: "metric",
            userPressureUnit: "PSI",
            updatedBy: "",
            logoLocation: null,
            updatedDate: "",
            lastAccessedAccountId: "0000",
            lastAccessedLocationId: "0000",
            lastAccessedAccountName: "",
            lastAccessedLocationName: "",
          },
          userProfile: {
            countryCode: "",
            emailAddress: null,
            firstName: "",
            lastName: "",
            middleName: "",
            phoneNumber: "",
            updatedDate: "",
            userId: "",
            userRole: null,
          },
        };
        let accountDataT = accountData;
        accountData = JSON.stringify(accountData);
        localStorage.setItem("accountInfo", accountData);
        localStorage.setItem("accountInfoUserMeasurementSystemValue", JSON.stringify(accountDataT.userSetting.userMeasurementSystemValue));
        localStorage.setItem("isEmailBtnShow", false);
        if (!localStorage.getItem("broadcastFag")) {
          localStorage.setItem("broadcastFag", true);
        }

        let currentUrl = window.location.href;
        let segments = currentUrl.split('/');
        let lastSegment = segments.pop();

        if (lastSegment !== 'login') {
          segments.push('login');
          let newUrl = segments.join('/');
          window.location.href = newUrl;
        }
      }
    })
  }, []);

  return (
      <StateProvider
        reducer={mainReducer}
        initialState={{ accountInfo: initialAccountState }}>
          <BrowserRouter>
          {/* <Route path="/login" component={LogIn} exact /> */}
                <HeaderRouting />
                <FooterNavigation />
          </BrowserRouter>
      </StateProvider>
  );
}

export default App;